import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { Home, Layers, Sparkles, ListChecks, Images, Settings } from "lucide-react";
import { useUser } from "../context/UserContext";
import { getDashboard } from "../lib/api";

const items = [
  { to: "/", label: "Accueil", icon: Home, key: "home", end: true },
  { to: "/cards", label: "Cartes", icon: Layers, key: "cards" },
  { to: "/matches", label: "Matchs", icon: Sparkles, key: "matches" },
  { to: "/answers", label: "Réponses", icon: ListChecks, key: "answers" },
  { to: "/photos", label: "Photos", icon: Images, key: "photos" },
  { to: "/settings", label: "Réglages", icon: Settings, key: "settings" },
];

export const Navigation = () => {
  const { currentUserId } = useUser();
  const [newMatches, setNewMatches] = useState(0);
  const [privatePhotos, setPrivatePhotos] = useState(0);

  useEffect(() => {
    if (!currentUserId) return;
    getDashboard(currentUserId)
      .then((d) => {
        setNewMatches(d.newMatches || 0);
        setPrivatePhotos(d.privatePhotos || 0);
      })
      .catch(() => {});
  }, [currentUserId]);

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      {items.map((it) => {
        const Icon = it.icon;
        const badge = it.key === "matches" ? newMatches : it.key === "photos" ? privatePhotos : 0;
        return (
          <NavLink
            key={it.key}
            to={it.to}
            end={it.end}
            data-testid={`nav-${it.key}`}
            className={({ isActive }) => `nav-item ${isActive ? "nav-active" : ""}`}
          >
            <span className="nav-icon-wrap">
              <Icon size={21} strokeWidth={1.5} />
              {badge > 0 && (
                <span className="nav-badge" data-testid={`nav-${it.key}-badge`}>
                  {badge}
                </span>
              )}
            </span>
            <span className="nav-label">{it.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default Navigation;
